(function () {
  const mapEl = document.getElementById('mv-inventory-map');
  if (!mapEl) return;

  let inv = {};
  try { inv = JSON.parse(mapEl.textContent || '{}'); } catch (e) { inv = {}; }

  function rafDebounce(fn) {
    let scheduled = false;
    return function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        fn();
      });
    };
  }

  function getVariantIdFromRow(row) {
    const marker = row.querySelector('[id*="_block_prc_discounts_"]');
    if (!marker || !marker.id) return null;
    const m = marker.id.match(/_block_prc_discounts_(\d+)$/);
    return m ? m[1] : null;
  }

  function normalizeBaseText(text) {
    return (text || '').replace(/\s*\([^)]*\)\s*$/, '').trim();
  }

  function setTextIfChanged(el, nextText) {
    if (!el) return;
    if ((el.textContent || '') !== nextText) {
      el.textContent = nextText;
    }
  }

  function translateLabels(row) {
    const optionLabelEls = row.querySelectorAll('.multivariants_block_option_label .mkmid_m');
    optionLabelEls.forEach((el) => {
      const txt = (el.textContent || '').trim();
      if (txt.toUpperCase() === 'SIZE') {
        setTextIfChanged(el, 'Talla');
      }
    });
  }

  function paintRow(row) {
    translateLabels(row);

    const variantId = getVariantIdFromRow(row);
    if (!variantId || !inv[variantId]) return;

    const qty = Number(inv[variantId].qty ?? 0);
    const available = Boolean(inv[variantId].available);
    const stockWrap = row.querySelector('.multivariants_block_stock_qty');
    if (stockWrap && stockWrap.style.display !== 'none') {
      stockWrap.style.display = 'none';
    }

    const holders = row.querySelectorAll(
      '.multivariants_block_last_holder_labels > .multivariants_block_label_holder'
    );

    const sizeValueEl = holders[1]?.querySelector('.multivariants_block_label .mkmid_m');
    if (sizeValueEl) {
      if (!sizeValueEl.dataset.baseText) {
        sizeValueEl.dataset.baseText = normalizeBaseText(sizeValueEl.textContent);
      }

      const base = sizeValueEl.dataset.baseText;
      const nextText = `${base} (${available ? qty + ' en stock' : 'Sin stock'})`;

      setTextIfChanged(sizeValueEl, nextText);
    }
  }

  function paintAll(root) {
    root.querySelectorAll('.multivariants_block_option_list').forEach(paintRow);
  }

  function attachToMultivariants(root) {
    let isPainting = false;

    const run = rafDebounce(() => {
      if (isPainting) return;

      isPainting = true;
      try {
        paintAll(root);
      } finally {
        isPainting = false;
      }
    });

    run();

    const localObs = new MutationObserver((mutations) => {
      let shouldRun = false;

      for (const m of mutations) {
        if (m.type !== 'childList') continue;
        if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
          shouldRun = true;
          break;
        }
      }

      if (shouldRun) run();
    });

    localObs.observe(root, { childList: true, subtree: true });

    root.addEventListener('change', run, true);
    root.addEventListener('input', run, true);
    root.addEventListener('click', run, true);
  }

  function init() {
    const root = document.getElementById('MULTIVARIANTS_APP_SECTION_PLACE');
    if (root) {
      attachToMultivariants(root);
      return;
    }

    const globalObs = new MutationObserver(() => {
      const r = document.getElementById('MULTIVARIANTS_APP_SECTION_PLACE');
      if (r) {
        globalObs.disconnect();
        attachToMultivariants(r);
      }
    });

    globalObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();